
window.addEventListener('load', () => {
  const footerLinksElements = document.getElementsByClassName('footer__block__links');
  if (footerLinksElements && footerLinksElements.length > 0) {
    const clickableElements = footerLinksElements[0].getElementsByTagName('p');
    const linkElements = footerLinksElements[0].getElementsByTagName('ul');

    if (clickableElements.length) {
      Array.from(clickableElements).forEach(el => {
        el.firstChild?.addEventListener('click', () => {
          if (el.classList.contains('--active')) {
            el.classList.remove('--active');
            (el.nextElementSibling as HTMLElement).style.display = 'none';
            return;
          }

          Array.from(clickableElements).forEach(allElement => {
            allElement.classList.remove('--active');
          });
          Array.from(linkElements).forEach(ulElement => {
            ulElement.style.display = 'none';
          });

          el.classList.add('--active');
          (el.nextElementSibling as HTMLElement).style.display = 'block';
        });
      });
    }
  }

  document.querySelectorAll('.is-drilldown-submenu-parent').forEach(el => {
    el.querySelector('a').addEventListener('click', () => {
      el.parentElement.classList.add('active-parent');
      el.parentElement.scrollTop = 0;
      el.scrollTop = 0;
    });
  });

  document.querySelectorAll('.js-drilldown-back').forEach(el => {
    el.addEventListener('click', () => {
      const parent = findActiveParentMenu(el);
      console.log(parent);
      if (parent) {
        parent.classList.remove('active-parent');
        parent.scrollTop = 0;
        parent.parentElement.scrollTop = 0;
      }
    })
  });
});

function findActiveParentMenu(el) {
  let parent = el.parentElement;
  while (parent) {
    if (parent.classList.contains('active-parent')) {
      return parent;
    }
    parent = parent.parentElement;
  }
  return null;
}

Array.from(document.getElementsByClassName('is-drilldown-submenu-parent')).forEach(firstEl => {
  Array.from(firstEl.getElementsByClassName('nested')).forEach(nestedEl => {
    if (nestedEl.getElementsByClassName('nested').length) {
      Array.from(nestedEl.getElementsByClassName('nested')).forEach(thirdLevel => {
        thirdLevel.parentElement.classList.add('is-drilldown-submenu-parent');
        let backLi = document.createElement('li');
        backLi.innerHTML = '<button></button>';
        backLi.classList.add('js-drilldown-back');
        thirdLevel.insertBefore(backLi, thirdLevel.children[0]);
      });
    }
  });
});

import SimpleLightbox from 'simplelightbox';
window.addEventListener('load', () => {
  let gallery = new SimpleLightbox('.lightbox__container div:not(.video-container)', {
    maxZoom: 5,
    loop: false,
    overlayOpacity: 0.6,
    navText: ['', ''],
    closeText: '',
    showCounter: false,
    animationSlide: false,
    animationSpeed: 50,
    fadeSpeed: 100,
    sourceAttr: 'data-zoom'
  });

  const zoomButton = document.querySelector('.zoom__link') as HTMLButtonElement;
  if (zoomButton) {
    zoomButton.addEventListener('click', function (event) {
      event.preventDefault();

      let activeSlideIndex = 0;

      const mediaGallery = document.getElementById('mediaGallery') as HTMLElement;
      if (mediaGallery && 'blazeSlider' in mediaGallery) {
        const blazeSlider = (mediaGallery as any).blazeSlider;
        activeSlideIndex = blazeSlider?.stateIndex || 0;
      }

      const galleryItems = document.querySelectorAll('.lightbox__container div:not(.video-container)');
      gallery.open(galleryItems[activeSlideIndex] || undefined);
    });
  }

  gallery.on('changed.simplelightbox', function (e) {
    const mediaGallery = document.getElementById('mediaGallery') as HTMLElement;
    const thumbnailGallery = document.getElementById('thumbnailGallery') as HTMLElement;

    const blazeSlider = mediaGallery ? (mediaGallery as any).blazeSlider : null;
    const blazeSliderThumbnail = thumbnailGallery ? (thumbnailGallery as any).blazeSlider : null;

    const index = e.target.getAttribute('data-slider-index');

    if (blazeSlider && blazeSlider.slideTo) {
      blazeSlider.slideTo(index);
    }

    if (blazeSliderThumbnail && blazeSliderThumbnail.slideTo) {
      blazeSliderThumbnail.slideTo(index);
    }
  });
});


document.addEventListener('DOMContentLoaded', function () {
  const button = document.getElementById('dropdownButton');
  const menu = document.getElementById('dropdownMenu');
  const arrow = document.getElementById('dropdownArrow');

  button?.addEventListener('click', () => {
    const isOpen = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', (!isOpen).toString());
    if (menu) menu.style.display = isOpen ? 'none' : 'block';
    arrow?.classList.toggle('rotate');
    if (!isOpen && menu) {
      const firstItem = menu.querySelector('[role="menuitem"]') as HTMLElement;
      firstItem?.focus();
    }
  });

  document.addEventListener('click', (e) => {
    if (
      button && menu &&
      !button.contains(e.target as Node) &&
      !menu.contains(e.target as Node)
    ) {
      button.setAttribute('aria-expanded', 'false');
      menu.style.display = 'none';
      arrow?.classList.remove('rotate');
    }
  });

  button?.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      button.click();
    } else if (e.key === 'ArrowDown' && menu) {
      e.preventDefault();
      const firstItem = menu.querySelector('[role="menuitem"]') as HTMLElement;
      firstItem?.focus();
    }
  });

  menu?.addEventListener('keydown', (e) => {
    const items = Array.from(
      menu.querySelectorAll('[role="menuitem"]')
    ) as HTMLElement[];
    const index = items.indexOf(document.activeElement as HTMLElement);

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      const next = (index + 1) % items.length;
      items[next]?.focus();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      const prev = (index - 1 + items.length) % items.length;
      items[prev]?.focus();
    } else if (e.key === 'Escape' && button && menu) {
      e.preventDefault();
      button.setAttribute('aria-expanded', 'false');
      menu.style.display = 'none';
      arrow?.classList.remove('rotate');
      button.focus();
    }
  });
});

async function validateEmailAndUpdateUI(emailInput, errorElement, lastValidation, originalEmail = null) {
  const email = emailInput.value;
  let isValid = true;

  if (email === originalEmail && originalEmail !== null) {
    isValid = true;
  } else if (lastValidation.email === email) {
    isValid = lastValidation.valid;
  } else {
    try {
      const xsrfToken = document.cookie.split('; ').find(row => row.startsWith('XSRF-TOKEN='))?.split('=')[1];
      const response = await fetch('/api/checkout/customers/isEmailAvailable', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-xsrf-token': xsrfToken ? decodeURIComponent(xsrfToken) : ''
        },
        body: JSON.stringify({ customerEmail: email })
      });
      const data = await response.json();
      lastValidation.email = email;
      lastValidation.valid = data.valid !== false;
      isValid = lastValidation.valid;
    } catch (error) {
      isValid = true;
    }
  }

  if (isValid === false) {
    errorElement.classList.remove('hide');
    emailInput.classList.add('invalid');
  } else {
    errorElement.classList.add('hide');
    emailInput.classList.remove('invalid');
  }

  return isValid;
}

(window as any).validateEmailAndUpdateUI = validateEmailAndUpdateUI;